"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserPermissions = exports.EPermissions = void 0;
/* istanbul ignore file */
const node_fetch_1 = __importDefault(require("node-fetch"));
const configment_1 = __importDefault(require("@ten-x/configment"));
var EPermissions;
(function (EPermissions) {
    EPermissions["PROXY_BIDDER"] = "PROXY_BIDDER";
    EPermissions["READ_ONLY"] = "READ_ONLY";
    EPermissions["READ_WRITE"] = "READ_WRITE";
})(EPermissions = exports.EPermissions || (exports.EPermissions = {}));
/**
 * Given a Central Auth generated token get
 * the user permissions from the RBAC system
 *
 * @param {string} caToken CA session token
 */
async function getUserPermissions(caToken) {
    const base = configment_1.default.get("ENTITLEMENTS_READ_API_URL");
    const tenant = configment_1.default.get("RBAC_TENANT");
    const url = `${base}/${tenant}/permissions`;
    const response = await (0, node_fetch_1.default)(url, {
        headers: { authorization: `Bearer ${caToken}` },
    });
    // If user has no roles, response will be a 204 (No Content)
    // so we need to handle this special case
    if (response.status === 204) {
        return { permissions: [] };
    }
    const body = await response.json();
    return body;
}
exports.getUserPermissions = getUserPermissions;
